/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { uploadFile } from "../../../../../api/order";
import { updateProduct } from "../../../../../api/product";
import AppLayout from "../../../../../layout/DashboardLayout";
import { orderSelector } from "../../../../../redux/slices/orderSlice";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  getImageList,
  getProductDetailsForUpdate,
  getRowIdWithImageUrl,
  getUploadedImageWithRowId,
  productSelector,
} from "../../../../../redux/slices/productSlice";
import ApplyToAllModal from "./components/ApplyToAllModal";
import MultipleVariantAddForm from "./components/MultipleVariantAddForm";
import TopProductDetailsForm from "./components/TopProductDetailsForm";
import UnableToQuoteModal from "./components/UnableToQuoteModal";
import VariantsDataTable from "./components/VariantsDataTable";
import { toast } from "react-toastify";

export default function AddProductWithVariant() {
  const { uploadedMediaFile } = useSelector(orderSelector);
  const { imageList, updateProductDetails, productInfo } =
    useSelector(productSelector);
  const dispatch = useDispatch();
  const [fileLink, setFileLink] = React.useState(null);
  const [title, setTitle] = useState("");
  const [sku, setSKU] = useState("");

  const navigate = useNavigate();
  const params = useParams();
  const savedProduct = productInfo?.products?.find(
    (product) => product._id === params.id
  );
  // const [variants, setVariants] = useState(savedProduct?.variant_options || []);
  const [variants, setVariants] = useState([]);

  const [countryList, setCountryList] = useState([]);

  const [productType, setProductType] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [applyToAllData, setApplyToAllData] = useState([]);

  const handleDispatch = () => {
    if (savedProduct?._id) {
      dispatch(
        updateProduct({
          productId: savedProduct?._id,
          updatePayload: updateProductDetails,
        })
      );
      dispatch(getUploadedImageWithRowId([]));
      dispatch(getRowIdWithImageUrl({}));
      navigate(-1);
    }
  };

  // handle number of option values and number of variants
  const optionValues = variants?.map((variant) => variant?.values);
  let variantList = [];
  const optionValuesLength = optionValues?.map((array) =>
    array?.length === 0 ? 1 : array.length
  );
  const totalVariants =
    optionValuesLength?.length > 0 &&
    optionValuesLength.reduce((a, b) => a * b);

  for (let i = 0; i < totalVariants; i++) {
    const variant = [];
    let temp = i;
    for (const arrayLength of optionValuesLength) {
      variant.push(optionValues[variant.length][temp % arrayLength]);
      temp = Math.floor(temp / arrayLength);
    }
    variantList.push({
      id: i + 1,
      title: savedProduct?.title || title || "",
      img: "",
      options: variant,
      sku: sku || savedProduct?.sku || "",
      price: 0.0,
      weight: 0,
    });
  }

  // manipulate variants for rendering in table
  const manipulateVariants = variantList.map((variant) => {
    const modifiedVariants = {
      sku: `${variant.sku}/${variant.options
        .map((option) => option)
        .join("/")}`,
      id: variant.id,
      title: variant.title,
      img: variant.img,
      options: variant.options,
      price: variant.price,
      weight: variant.weight,
      product_type:productType
    };
    return modifiedVariants;
  });

  const uploadMedia = () => {
    const formData = new FormData();
    formData.append("media", fileLink);
    dispatch(uploadFile(formData));
  };

  useEffect(() => {
    if (fileLink) {
      uploadMedia();
    }
  }, [fileLink]);

  useEffect(() => {
    if (uploadedMediaFile?.media && fileLink) {
      dispatch(getImageList([...imageList, { src: uploadedMediaFile?.media }]));
      setFileLink(null);
    }
  }, [dispatch, uploadedMediaFile?.media]);

  useEffect(() => {
    dispatch(
      getProductDetailsForUpdate({
        ...updateProductDetails,
        title: title || savedProduct?.title,
        sku: sku || savedProduct?.sku,
        product_type: productType || savedProduct?.product_type,
        product_category: productCategory || savedProduct?.product_category,
        target_shipping_countries:
          countryList?.length > 0
            ? countryList
            : savedProduct?.target_shipping_countries,
        images: imageList || savedProduct?.images,
        variant_options: variants || savedProduct?.variants,
      })
    );
  }, [
    imageList.length,
    variants,
    productCategory,
    productType,
    countryList,
    title,
  ]);

  useEffect(() => {
    dispatch(getImageList(savedProduct?.images || imageList));
  }, [savedProduct?.images]);

  const mergedVariants =
    applyToAllData?.length > 0 &&
    manipulateVariants?.map((maniputeVariant, i) => {
      const applyVariant = applyToAllData[i];
      const normalizeObj = {
        ...maniputeVariant,
        price: applyVariant?.price,
        weight: applyVariant?.weight,
      };
      return normalizeObj;
    });

  return (
    <AppLayout>
      <div>
        <div className="flexbox">
          <div style={{ display: "flex" }}>
            <ArrowBackIosIcon
              sx={{
                fontSize: "18px",
                color: "#9d9d9d",
                cursor: "pointer",
                marginTop: "10px",
              }}
              onClick={() => navigate(-1)}
            />
            <h4>{savedProduct?.title || "Product Title Not available"}</h4>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              justifyItems: "flex-end",
            }}
          >
            <UnableToQuoteModal savedProduct={savedProduct} />
            <Button
              variant="purple"
              disabled={
                !updateProductDetails?.variants ||
                updateProductDetails?.variants?.length < 1 ||
                sku === ""
              }
              sx={{
                width: "auto",
                height: "45px",
                marginLeft: "10px",
                fontSize: "14px",
              }}
              onClick={() => {
                if (updateProductDetails?.variants?.length > 0) {
                  const variantsWithNonZeroValue =
                    updateProductDetails?.variants.filter(
                      (item) =>
                        parseInt(item.price) === 0 ||
                        parseInt(item.weight) === 0
                    );

                  if (variantsWithNonZeroValue.length) {
                    toast.warning(
                      "Variant price and weight can not be zero"
                    );
                  } else {
                    handleDispatch();
                  }
                }
              }}
            >
              Submit Quotation
            </Button>
          </div>
        </div>
        <div>
          <TopProductDetailsForm
            setCountryList={setCountryList}
            setProductCategory={setProductCategory}
            setProductType={setProductType}
          />
        </div>
        <div
          style={{
            padding: "20px",
            marginTop: "40px",
            borderRadius: "3px",
            maxHeight: "auto",
            boxShadow: "0px 8px 16px rgba(219, 231, 243, 0.8)",
          }}
        >
          <MultipleVariantAddForm
            variants={variants}
            setVariants={setVariants}
            title={title}
            setTitle={setTitle}
            sku={sku}
            setSKU={setSKU}
            setFileLink={setFileLink}
            productType={productType}
            setProductType={setProductType}
          />
          <div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <ApplyToAllModal
                variants={manipulateVariants}
                setApplyToAllData={setApplyToAllData}
              />
            </div>
            <VariantsDataTable
              variants={mergedVariants || manipulateVariants}
              // applyToAllData={applyToAllData}
              applyToAllData={applyToAllData}
              title={title}
              sku={sku}
            />
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
